/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BrokerPaginationResponseDto,
  BrokerResponseDto,
  CreateBrokerPayloadDto,
  ErrorResponse,
  ReplaceBrokerPayloadDto,
} from '../models/index';
import {
    BrokerPaginationResponseDtoFromJSON,
    BrokerPaginationResponseDtoToJSON,
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoToJSON,
    CreateBrokerPayloadDtoFromJSON,
    CreateBrokerPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReplaceBrokerPayloadDtoFromJSON,
    ReplaceBrokerPayloadDtoToJSON,
} from '../models/index';

export interface CreateBrokerRequest {
    createBrokerPayloadDto: CreateBrokerPayloadDto;
}

export interface DeleteBrokerRequest {
    brokerId: string;
}

export interface FilterBrokersRequest {
    searchText?: string;
    status?: FilterBrokersStatusEnum;
    field?: FilterBrokersFieldEnum;
    order?: FilterBrokersOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface GetBrokerByIdRequest {
    brokerId: string;
}

export interface ReplaceBrokerRequest {
    brokerId: string;
    replaceBrokerPayloadDto: ReplaceBrokerPayloadDto;
}

/**
 * 
 */
export class BrokerApi extends runtime.BaseAPI {

    /**
     * Create broker
     */
    async createBrokerRaw(requestParameters: CreateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrokerResponseDto>> {
        if (requestParameters['createBrokerPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createBrokerPayloadDto',
                'Required parameter "createBrokerPayloadDto" was null or undefined when calling createBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/broker`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBrokerPayloadDtoToJSON(requestParameters['createBrokerPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrokerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create broker
     */
    async createBroker(requestParameters: CreateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrokerResponseDto> {
        const response = await this.createBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete broker by id
     */
    async deleteBrokerRaw(requestParameters: DeleteBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling deleteBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/broker/{brokerId}`.replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete broker by id
     */
    async deleteBroker(requestParameters: DeleteBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBrokerRaw(requestParameters, initOverrides);
    }

    /**
     * Filter brokers
     */
    async filterBrokersRaw(requestParameters: FilterBrokersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrokerPaginationResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/broker/filter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrokerPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter brokers
     */
    async filterBrokers(requestParameters: FilterBrokersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrokerPaginationResponseDto> {
        const response = await this.filterBrokersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get broker by id
     */
    async getBrokerByIdRaw(requestParameters: GetBrokerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrokerResponseDto>> {
        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling getBrokerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/broker/{brokerId}`.replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrokerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get broker by id
     */
    async getBrokerById(requestParameters: GetBrokerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrokerResponseDto> {
        const response = await this.getBrokerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace broker
     */
    async replaceBrokerRaw(requestParameters: ReplaceBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrokerResponseDto>> {
        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling replaceBroker().'
            );
        }

        if (requestParameters['replaceBrokerPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'replaceBrokerPayloadDto',
                'Required parameter "replaceBrokerPayloadDto" was null or undefined when calling replaceBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/broker/{brokerId}/replace`.replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceBrokerPayloadDtoToJSON(requestParameters['replaceBrokerPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrokerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Replace broker
     */
    async replaceBroker(requestParameters: ReplaceBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrokerResponseDto> {
        const response = await this.replaceBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterBrokersStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type FilterBrokersStatusEnum = typeof FilterBrokersStatusEnum[keyof typeof FilterBrokersStatusEnum];
/**
 * @export
 */
export const FilterBrokersFieldEnum = {
    Name: 'name'
} as const;
export type FilterBrokersFieldEnum = typeof FilterBrokersFieldEnum[keyof typeof FilterBrokersFieldEnum];
/**
 * @export
 */
export const FilterBrokersOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterBrokersOrderEnum = typeof FilterBrokersOrderEnum[keyof typeof FilterBrokersOrderEnum];
